import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  min-width: 200px;
  margin-left: 15px;
  border: 1px solid ${props => props.theme.palette.general.grey};
  border-radius: 5px;

  h4 {
    margin: 0;
    border-bottom: 1px solid ${props => props.theme.palette.general.grey};
    padding: 10px;
    color: ${props => props.theme.palette.primary.alphaDark};
    text-transform: uppercase;
    font: ${font('default', 'medium', '18px/1')};
  }

  ul {
    list-style: none;
    padding: 10px;
    margin: 0;

    li {
      margin-bottom: 5px;
    }

    a {
      font: ${font('default', 'bold', '16px/1.5')};
      color: ${props => props.theme.palette.general.greyDark};
      text-decoration: none;
    }
  }
`
